const renderDefaultNotifications = {
    shouldRender: (renderProps) => {
        return renderProps.isLoggedIn;
    },
    makeRenderer: (renderProps) => (props) => {
        return renderProps.renderNotifications(props);
    },
};
const renderNothing = {
    shouldRender: (renderProps) => {
        return (!renderProps.isLoggedIn || renderProps.currentUrl.includes('/onboarding'));
    },
    makeRenderer: () => () => {
        return null;
    },
};
const configs = [
    renderNothing,
    renderDefaultNotifications,
];
const findNotificationsRenderer = (renderProps) => {
    const foundConfig = configs.find((config) => {
        return config.shouldRender(renderProps);
    });
    return foundConfig && foundConfig.makeRenderer(renderProps);
};
export default findNotificationsRenderer;
//# sourceMappingURL=findNotificationsRenderer.js.map
// @zapier/universal-layout@11.4.2 (c660b09a7)
